'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Sortable = require('sortablejs/Sortable');

var _Sortable2 = _interopRequireDefault(_Sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryController = function () {
  function CategoryController(ImagesDataProvider, $state, APPLICATION_URL) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CategoryController);
    this.ImagesDataProvider = ImagesDataProvider;
    this.$state = $state;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
    this.type = 1;
    this.field = 'image_id';
    this.order_type = 'desc';
    this.col = 0;
    this.colTopDown = 0;
    this.APPLICATION_URL = APPLICATION_URL;
    this.parentId = $state.params.parentId;
    if (this.parentId) {
      this.pageLimit = '9999';
      this.field = 'order_by';
      this.order_type = 'asc';
      var el = document.getElementById('items');
      var vm = this;
      vm.sortingLog = [];
      var sortable = _Sortable2.default.create(el, {
        onStart: function onStart(evt) {
          evt.oldIndex;
          console.log('start');
        },
        onEnd: function onEnd(evt) {
          var oldData = angular.copy(vm.categories);
          var i = 0;
          if (evt.oldIndex < evt.newIndex) {
            for (i = evt.oldIndex; i <= evt.newIndex; i++) {
              if (i == evt.newIndex) {
                vm.categories[i] = oldData[evt.oldIndex];
              } else {
                vm.categories[i] = oldData[i + 1];
              }
            }
          }
          if (evt.oldIndex > evt.newIndex) {
            for (i = evt.oldIndex; i >= evt.newIndex; i--) {
              if (i == evt.newIndex) {
                vm.categories[i] = oldData[evt.oldIndex];
              } else {
                vm.categories[i] = oldData[i - 1];
              }
            }
          }
          vm.categories.map(function (i) {
            vm.sortingLog.push(i.image_id);
          });
          ImagesDataProvider.updateImageOrder(vm.sortingLog).then(function (result) {
            vm.getImages();
          });
          vm.sortingLog = [];
        }
      });
    } else {
      this.parentId = 0;
    }
    this.getImages();
  }

  (0, _createClass3.default)(CategoryController, [{
    key: 'getSortRecors',
    value: function getSortRecors(field, order_type, col, colTopDown) {
      this.field = field;
      this.order_type = order_type;
      this.col = col;
      this.colTopDown = colTopDown;
      this.getImages();
    }
  }, {
    key: 'getImages',
    value: function getImages() {
      var vm = this;
      var data = [];
      data.currentPage = vm.currentPage;
      data.pageLimit = vm.pageLimit;
      data.field = vm.field;
      data.order_type = vm.order_type;
      data.image_category_id = vm.parentId;
      vm.ImagesDataProvider.getImages(data).then(function (result) {
        vm.categories = result.data;
        vm.categoriesTotal = result.total;
      });
    }
  }, {
    key: 'removeRecord',
    value: function removeRecord(id) {
      if (confirm("Are you sure to delete!") !== true) {
        return false;
      }
      var vm = this;
      vm.ImagesDataProvider.removeImage(id).then(function (res) {
        vm.getImages();
      });
    }
  }]);
  return CategoryController;
}();

// WEBPACK FOOTER //


exports.default = CategoryController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/images/components/list/controller.js
 **/